import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to El Paso needed",
      "Ideal for Kirtland AFB and Sandia Labs families",
      "Perfect for ABQ business travelers to Mexico and Europe",
      "Great for UNM students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Albuquerque post offices",
      "Good for planned international trips from ABQ Sunport",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Bernalillo County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: El Paso (~270 mi) — no Albuquerque walk-in",
      "NPIC appointment required before traveling to El Paso",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function AlbuquerqueProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Albuquerque"
      introText="Albuquerque travelers — Kirtland AFB military families, Sandia National Labs researchers heading to international conferences, UNM students studying abroad in Latin America and Europe, and business travelers flying out of Albuquerque International Sunport (ABQ) — have several options for getting a passport fast. Here is how they compare, and why most New Mexico residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to El Paso."
      options={options}
      emergencyDescription="Albuquerque does not have its own regional passport agency. The closest is El Paso (~270 mi, 4+ hrs via I-25/I-10). Kirtland AFB families with deployment orders face 8+ hours round-trip minimum. I-25 construction through Las Cruces and winter conditions on Raton Pass add unpredictable delays. During monsoon season, flash flooding on I-25 can make the route hazardous."
      disclaimerText="*Processing speed depends on eligibility and documentation. Albuquerque does not have a regional passport agency — the closest is El Paso, TX. Not all applicants qualify for Regional Agency Processing."
    />
  );
}